<div class="w-100 jmDialog bg-white" style="min-height:400px;">
	<div class="row jmPageTitle border-bottom border-black p-3">
		<div class="col-10 ">
			Job Offer Information
		</div>
		<div class="col-2 text-end">
			<span role="button" class="jmCloseBtn" (click)="cancelOffer($event)"></span>
		</div>
	</div>

	@if (downloadingOffer) {
		<span class="jmWidgetLoadingIcon40"></span>
	}

	@if (!downloadingOffer && offer == null) {
		<div>
			No offer is found.
		</div>
	}

	@if (!downloadingOffer && offer != null) {
		<table class="table table-borderless">
			<tbody>
				<tr>
					<td class="ps-3">Your Offer for:</td>
					<td class="pe-3">{{offer.JobTitle}}</td>
				</tr>
				<tr>
					<td class="ps-3">Job Status:</td>
					<td class="pe-3">{{offer.JobStatus}}</td>
				</tr>
				<tr>
					<td class="ps-3">Status:</td>
					<td class="pe-3">{{offer.OfferStatus}}</td>
				</tr>
				<tr>
					<td class="ps-3">Date Offer:</td>
					<td class="pe-3">{{offer.OfferTime | formatDate}}</td>
				</tr>
				<tr class="border-top">
					<td colspan="2" class="ps-3 text-muted">Offer Details:</td>
				</tr>
				<tr>
					<td class="ps-3">Message</td>
					<td class="pe-3">
						<textarea readonly class="w-100 mt-1 mb-1" style="height: 150px; background-color: #eee; ">{{offer.Message}}</textarea>
					</td>
				</tr>
				@if (offer.Filename.length > 0) {
					<tr>
						<td class="ps-3">Attachment</td>
						<td class="pe-3">
							<span>
								{{offer.Filename}}
							</span>
							<span class="ms-2">
								<img class="jmFileImage" [src]="fileIcon" onerror="this.src='assets/images/blank.png'" />
							</span>
							<button (click)="downloadAttachment($event)" type="button" class="btn btn-outline-primary ms-4">Download <i class="icnDownload"></i></button>
						</td>
					</tr>
				}
				<tr class="border-top">
					<td colspan="2" class="ps-3 text-muted">Contact Info:</td>
				</tr>
				<tr>
					<td class="ps-3">Email:</td>
					<td class="pe-3">{{offer.Email}}</td>
				</tr>
				<tr>
					<td class="ps-3">Phone:</td>
					<td class="pe-3">{{offer.Phone}}</td>
				</tr>
			</tbody>
		</table>
	}

	@if (offer != null) {
		<div class="p-4 text-end border-top">
			@if(canOffer) {
				@if (!replyingOffer) {
					<button (click)="declineOffer($event)" class="btn btn-outline-dark me-3">Decline</button>
				}
				@if (!replyingOffer) {
					<button (click)="acceptOffer($event)" class="btn btn-primary">Accept</button>
				}
				@if (replyingOffer) {
					<span class="jmWidgetLoadingIcon20"></span>
				}
			}
			@else {
				<button (click)="cancelOffer($event)" class="btn btn-outline-dark">Close</button>
			}
		</div>
	}
</div>

